import { render, staticRenderFns } from "./UsuarioFronteraForm.vue?vue&type=template&id=4ff46cfd"
import script from "./UsuarioFronteraForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFronteraForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFronteraForm.vue?vue&type=style&index=0&id=4ff46cfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports